import environment from '@environments/environment';

/**
 * Absolute URL of the AIIRB review Jo owns for a submission, or null when this
 * environment has no Jo frontend yet (joBaseUrl ships empty there) -- callers must
 * fall back to in-app navigation instead.
 *
 * Jo is served from eRM's own origin under a path prefix (`/submitassist`), so this is
 * a same-origin URL. That shared origin is also a shared Okta token store: Jo reads the
 * session eRM already established instead of being told, in the URL, who is signed in.
 */
export function buildJoReviewUrl(
  reviewSlug: string,
  analystReview = false,
): string | null {
  if (!environment.joBaseUrl) {
    return null;
  }
  const path = `${environment.joBaseUrl}/reviews/${reviewSlug}`;
  return analystReview ? `${path}/analyst-review` : path;
}

/**
 * Sends the browser to the AIIRB review Jo owns for a submission. A plain location
 * assignment rather than router navigation -- Jo shares this origin but is a separate
 * application, so handing control over needs a full document load.
 * Pass `analystReview` while the submission is still in pre-review (`qc_check`) and AI
 * IRB is actively analyzing it, to send Jo to the analyst-facing view of the review
 * instead of the default one.
 * Returns false without navigating when the environment has no Jo frontend.
 */
export function redirectToJoReview(
  reviewSlug: string,
  analystReview = false,
): boolean {
  const url = buildJoReviewUrl(reviewSlug, analystReview);
  if (!url) {
    return false;
  }
  window.location.href = url;
  return true;
}
